import { Tag, Col, Panel, Table, Whisper, IconButton, Popover, Dropdown } from "rsuite"
import MoreIcon from '@rsuite/icons/legacy/More';

const { Cell } = Table;

export default function TagCell ({ rowData, dataKey, ...props }) {
    return (
        <Cell {...props} className="tag-cell" >
            <div style={{display: "flex", flexDirection: "column"}} >
                { rowData[dataKey]?.length > 0 && rowData[dataKey].map(
                    (item, index) =>
                        <Tag key={index}>{item}</Tag>
                    )
                }
            </div>
        </Cell>
    );
};